module.exports = __webpack_public_path__ + "static/app-2-474f072655425aa62ce8a5e97799c279.png";